import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LenderLogos } from "@/components/common";
import { FiArrowRight } from "@/lib/icons";

/**
 * Lender panel section showing partner lenders
 */
export function LenderPanel() {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="section-label mb-4">Our Lender Panel</p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl max-w-2xl mx-auto leading-tight">
            Access to 70+ lenders including all major banks
          </h2>
        </div>

        {/* Lender Logos Grid */}
        <div className="mb-12">
          <LenderLogos variant="grayscale" />
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button asChild className="btn-pill h-11 px-6">
            <Link to="/lenders">
              View All Lenders
              <FiArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
